const HIDDEN_PAYMENT_STATUSES = new Set(['failed', 'declined', 'pending', 'processing'])

function isCashTenderPayment (payment) {
  if (!payment) return false
  if (payment.payment_method === 'cash') return true
  const type = String(payment.payment_method_type || '').toLowerCase()
  return payment.payment_method === 'split' && type === 'cash'
}

function isVisibleCashPayment (payment) {
  if (!isCashTenderPayment(payment)) return false
  const status = String(payment.status ?? '').toLowerCase()
  return !HIDDEN_PAYMENT_STATUSES.has(status)
}

/**
 * First visible cash payment row on a finalized sale (full or split tender).
 * @param {object|null|undefined} sale
 * @returns {object|null}
 */
export function primaryCashPaymentFromSale (sale) {
  if (!sale) return null
  const payments = Array.isArray(sale.payments) ? sale.payments : []
  const cash = payments.find(isVisibleCashPayment)
  if (cash) return cash
  if (sale.payment_method === 'cash' && payments.length === 0) {
    return { amount_received: 0, change_given: 0 }
  }
  return null
}

/**
 * @param {object|null|undefined} sale
 * @returns {boolean}
 */
export function saleHasVisibleCashPayment (sale) {
  return primaryCashPaymentFromSale(sale) != null
}
